import styled from 'styled-components';

export const TrainingDetailHeroSection = styled.section`
  padding: 60px 0;

  @media only screen and (max-width: 767px) {
    padding-top: 10px;
  }

  .discount {
    span {
      display: inline-block;
      color: ${({ theme: { colors } }) => colors.pink};
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.06px;
      line-height: 30px;
      vertical-align: top;
      margin-top: 5px;
      margin-left: 5px;

      br {
        display: none;
      }
    }
  }

  h1 {
    color: ${({ theme: { colors } }) => colors.darkGrey};
    font-size: 48px;
    letter-spacing: -0.36px;
    line-height: 59px;

    @media only screen and (max-width: 767px) {
      font-size: 32px;
      line-height: 1.3;
      margin-top: 10px;
      display: flex;
      justify-content: flex-start;

      span {
        display: inline-block;
        max-width: 50%;
      }
    }
  }

  .d-flex {
    margin: 0 -10px;
    justify-content: space-between;

    & > div {
      margin: 10px;

      @media only screen and (max-width: 1200px) {
        min-width: calc(50% - 30px);
        max-width: calc(50% - 30px);
        flex: unset;
      }

      &:first-child {
        max-width: 300px;

        .subtitle {
          display: inline-block;
          max-width: 300px;

          @media only screen and (max-width: 767px) {
            max-width: 150px;
          }
        }
      }

      &:nth-child(2) {
        min-width: 300px;
        flex: 1;
        @media only screen and (max-width: 1200px) {
          min-width: unset;
        }
      }

      &:nth-child(3) {
        flex: 1;
        @media only screen and (max-width: 767px) {
          min-width: 190px;
        }
      }

      &:last-child {
        margin-top: 50px;

        @media only screen and (max-width: 767px) {
          min-width: unset;
          .pink-btn {
            min-width: 120px !important;
            padding: 9px 10px !important;
          }
        }
      }
    }

    span {
      color: ${({ theme: { colors } }) => colors.darkGrey};
    }

    .title {
      display: block;
      font-size: 16px;
      line-height: 30px;
      letter-spacing: 0.06px;
      margin-bottom: 5px;
    }

    .subtitle {
      color: #0a090b;
      font-family: 'Proxima Nova';
      font-size: 36px;
      font-weight: 600;
      letter-spacing: -0.27px;
      line-height: 44px;

      @media only screen and (max-width: 767px) {
        font-size: 24px;
        line-height: 1.2;
      }
    }

    .pink-btn {
      @media only screen and (min-width: 1201px) {
        padding: 14px 53px;
      }
    }

    .fully-booked {
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.18px;
      line-height: 28px;
      text-align: center;
      position: relative;
      background-color: #000000;
      padding: 9px 15px;
      font-family: 'Proxima Nova';
      font-weight: 600;
    }  
  }
`;

export const TrainingDetailContainer = styled.div`
  .training-schedule-main {
    padding: 90px 0 80px;
    background-color: #fafafa;
  }
  .training-schedule-block .medium-heading {
    font-size: 36px;
    font-weight: bold;
    letter-spacing: -0.27px;
    line-height: 41px;
    margin-bottom: 70px;
  }

  .training-summary {
    display: flex;

    div {
      flex: 1;
    }

    div:first-child {
      margin-right: 10px;
    }

    @media only screen and (max-width: 767px) {
      flex-direction: column;

      div:first-child {
        margin-right: 0px;
      }
    }
  }

  .training-summart-without-bio {
    .summary-section {
      column-count: 2;
      column-gap: 40px;
    }
    @media only screen and (max-width: 767px) {
      .summary-section {
        column-count: 1;
      }
    }
  }

  /* 
  .training-schedule-txt ul {
    padding-left: 15px;

    li {
      color: #0a090b;
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 30px;
    }
  } */
  .training-dates-main {
    padding-top: 110px;
  }
  .single-training-date {
    padding: 34px 32px;
    background-color: #ff4552;
    height: 100%;

    h3 {
      color: #ffffff;
      font-size: 36px;
      font-weight: bold;
      letter-spacing: -0.27px;
      line-height: 41px;
      margin-bottom: 0;
    }

    p {
      font-size: 15px;
      /* font-weight: 600; */
      /* letter-spacing: 0.89px; */
      line-height: 1.7;
      color: #ffffff;
      /* text-transform: uppercase; */
      margin: 10px 0 5px;
      font-family: 'Proxima Nova';
    }

    ul {
      color: #ffffff;
      font-size: 15px;
      letter-spacing: -0.12px;
      line-height: 30px;
      margin-left: 16px;
    }
  }
  .prerequisites-main {
    padding: 138px 0 130px;
    background-color: #ff4552;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      background-color: #222136;
      right: 0;
      width: 50%;
      height: 100%;
      top: 0;
      bottom: 0;
    }
  }
  .prerequisites-single p {
    color: #ffffff;
  }

  .prerequisites-single ul {
    margin: 0 0 0 15px;

    .small-heading {
      margin-bottom: 30px;
    }

    li {
      color: #ffffff;
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 26px;
      margin-bottom: 10px;
    }
  }

  .pricing-area {
    text-align: center;
    padding: 50px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin-bottom: 50px;

    h2 {
      color: #ffffff;
      font-size: 36px;
      font-weight: bold;
      letter-spacing: -0.27px;
      line-height: 41px;
      text-align: center;
    }

    h3 {
      color: #ffffff;
      font-size: 85px;
      font-weight: bold;
      letter-spacing: -0.63px;
      line-height: 79px;
      text-align: center;
      margin: 50px 0;
    }

    h3.price-strike {
      margin-bottom: 13px;
    }

    .amazing-offer {
      color: #ffffff;
      font-family: 'Proxima Nova';
      font-size: 24px;
      letter-spacing: -0.18px;
      line-height: 46px;
      margin-bottom: 50px;
    }

    .price-strike:after {
      border-bottom: 0.125em solid red;
      content: '';
      left: 0;
      margin: 30px auto 0 auto;
      width: 250px;
      position: absolute;
      right: 0;
    }

    .white-btn {
      &:hover {
        background-color: ${({ theme: { colors } }) => colors.pink};
      }

      &:focus {
        background-color: ${({ theme: { colors } }) => colors.pinkHover};
      }
    }
  }

  .what-you-get-block {
    h2 {
      font-size: 36px;
      font-weight: bold;
      letter-spacing: -0.27px;
      line-height: 41px;
      text-align: center;
      color: #fff;
    }

    p {
      text-align: center;
      color: #fff;
    }

    ul {
      text-align: left;
      color: #fff;
    }

    .benefits {
      width: 750px;
      padding-left: 95px;
      ul {
        list-style-position: inside;

        li {
          margin: 12px 0;
          font-size: 23px;
          lineheight: 46px;
          letter-spacing: -0.18px;
        }
      }
    }
  }
  .what-get-img {
    height: 54px;
    width: 54px;
    background-color: #222136;
    line-height: 54px;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
    margin-bottom: 30px;

    svg,
    img {
      vertical-align: middle;
    }
  }
  .what-get-single {
    text-align: center;
    margin: 15px 0;

    h3 {
      color: #ffffff;
      font-size: 30px;
      font-weight: bold;
      letter-spacing: -0.24px;
      line-height: 37px;
      text-align: center;
    }

    p {
      line-height: 24px;
    }
  }

  .what-you-get-sec {
    padding: 60px 0 110px;
  }
  .training-faq-main {
    padding: 110px 0;
  }

  .faq-text {
    max-height: 0;
    overflow: hidden;
    transition: all 0.4s;

    ul {
      font-size: 16px;
      line-height: 1.875;
      margin-bottom: 15px;
      margin-left: 20px;
    }
  }

  .faq-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #c8c8c8;
    padding: 22px 0;
    width: 100%;

    .question {
      display: block;
      color: #0a090b;
      font-size: 21px;
      letter-spacing: -0.16px;
      line-height: 30px;
      text-align: left;
    }
  }
  .faq-arrow {
    font-size: 26px;
    padding-right: 15px;

    i {
      transition: all 0.3s;
    }
  }

  .course-overview {
    .section-title {
      margin-top: 80px;
      color: #0a090b;
      font-family: Vollkorn;
      font-size: 36px;
      font-weight: bold;
      letter-spacing: -0.27px;
      line-height: 41px;
      text-align: center;
      margin-bottom: 13px;
    }

    .section-details {
      color: #0a090b;
      font-family: 'Proxima Nova';
      font-size: 24px;
      font-weight: 100;
      letter-spacing: 0.02px;
      line-height: 30px;
      text-align: center;
      margin-bottom: 66px;
    }

    .expand-all-btn {
      color: #ff4552;
      font-family: 'Proxima Nova';
      font-size: 14px;
      letter-spacing: -0.1px;
      line-height: 30px;
      border: none;
    }

    .course-table {
      margin-bottom: 129px;
      .module-container {
        display: flex;
      }
    }

    .course-table div:first-child .course-module {
      .course-module-heading {
        border-top: none;
      }
    }

    .week-number-container {
      display: flex;
      flex-direction: column;
      margin-right: 45px;
      align-items: center;
      padding-top: 25px;
    }

    .week {
      font-size: 14px;
    }

    span.hidden {
      visibility: hidden;
    }

    .course-module-heading {
      div:first-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }
    }

    .week-number {
      color: rgba(10, 9, 11, 0.7);
      font-family: 'Proxima Nova';
      font-size: 28px;
      letter-spacing: 0;
      line-height: 28px;
    }

    .course-module {
      width: 100%;

      .course-module-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #979797;
        width: 100%;

        .course-module-title {
          display: block;
          color: #0a090b;
          font-family: 'Proxima Nova';
          font-size: 18px;
          font-weight: 600;
          letter-spacing: -0.13px;
          line-height: 30px;
          text-align: left;
        }

        .topic-count {
          margin-right: 100px;
          color: #0a090b;
          font-family: 'Proxima Nova';
          font-size: 16px;
          letter-spacing: -0.12px;
          line-height: 30px;
        }
      }
    }

    .course-module-topics {
      max-height: 0;
      overflow: hidden;
      transition: all 0.4s;

      ul {
        color: #0a090b;
        font-family: 'Proxima Nova';
        font-size: 18px;
        letter-spacing: -0.13px;
        line-height: 39px;
        margin-bottom: 38px;
        margin-left: 20px;
        list-style-type: none;
      }
    }

    .expand-arrow {
      font-size: 26px;
      padding-right: 24px;

      i {
        transition: all 0.3s;
      }
    }
  }
  @media (max-width: 990px) {
    .what-get-single h3 {
      font-size: 24px;
      line-height: 33px;
    }
  }
  @media (max-width: 767px) {
    .training-schedule-block .medium-heading {
      margin-bottom: 40px;
    }
    .training-schedule-main {
      padding: 50px 0;
    }

    .training-dates-main {
      & > .row > div {
        margin-bottom: 25px;
      }
    }

    .prerequisites-main::before {
      display: none;
    }
    .prerequisites-single {
      padding: 73px 0;
      text-align: center;
    }
    .prerequisites-single.mob-prerequisites {
      background-color: #222136;
      margin: 0 -15px;
      padding: 73px 15px;
    }
    .prerequisites-main {
      padding: 0;
    }
    .prerequisites-single ul li {
      font-size: 14px;
      list-style-position: inside;
    }
    .pricing-area h2 {
      font-size: 32px;
    }
    .what-you-get-block h2 {
      font-size: 32px;
    }
    .what-get-single h3 {
      font-size: 21px;
      line-height: 31px;
    }
    .what-you-get-sec {
      padding: 60px 0;
    }
    .training-faq-main {
      padding: 60px 0;
    }
    .faq-heading a {
      font-size: 18px;
      line-height: 30px;
    }
  }
  @media (max-width: 475px) {
    .benefits {
      width: auto !important;
      padding-left: 0 !important;
    }

    .expand-all-btn {
      display: none;
    }

    .module-container {
      flex-direction: column;
      .week-number-container {
        border-top: 1px solid #979797 !important;
        margin-right: 0;
        margin-bottom: 20px;
      }
    }

    .week-number-container {
      .hidden {
        display: none;
      }
    }

    .week-number-container.hidden {
      display: none;
    }

    .course-module-heading {
      div:first-child {
        display: flex;
        flex-direction: column;
        align-items: baseline !important;
      }
    }

    .course-table div:first-child .course-module {
      .course-module-heading {
        border-top: 1px solid #979797 !important;
      }
    }

    .course-table div:first-child {
      .week-number-container {
        border-top: none !important;
      }
    }
  }
`;
